import type { SVGProps } from "react";

export function UploadIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			fill="none"
			height="1px"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			viewBox="0 0 24 24"
			width="1px"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
			<polyline points="17 8 12 3 7 8" />
			<line x1="12" x2="12" y1="3" y2="15" />
		</svg>
	);
}
